import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import './style.css';
import cx from 'classnames';
import GenerateColor from 'common/utils/generateTextColor.js'
import TruncateText from 'common/components/elements/truncate-text';

const Filter = ({
   data,
   label,
   activeFilter,
   onSelectFilter,
   multipl,
   onCancelFilter,
   className,
   overflow,
   status,
   membership,
   height,
   marginLeft,
   paddingX,
   showNewStyles,
   storeProps,
   flexClassNames,
   activeTextClassName,
   passiveTextClassName,
   hideCancelButton,
   passiveBackground,
   activeBackground,
   customStyles,
   children,
   passiveIconColor,
   activeIconClassName,
   passiveIconClassName,
   classNames,
   disabled,
}) => {
   let generateTextColor = GenerateColor.adaptColor(window.skinSecondaryColor)
   return (
      <div className={ `h-full w-full select-none ${ className }` }>
         {
            label && (
               <span style={ { lineHeight: '16px' } } className='leading-none text-sm text-placeholder dark:text-placeholder-dark mb-px block ml-6 font-medium'>{label}</span>
            )
         }
         <div
            className={ `flex overflow-${ overflow } w-full py-2 scrolling-touch ${ flexClassNames }` }
         >
            {
               data && data.map((v, i) => {
                  let active = false;
                  if(multipl) {
                     active = activeFilter?.includes(v.value);
                  } else {
                     active = activeFilter === v.value;
                  }
                  return (
                     <div
                        role='presentation'
                        onClick={ () => {
                           if(disabled) {
                              return
                           }
                           onSelectFilter(v.value, v.filter_type)
                        } }
                        key={ i.toString() }
                        className={
                           cx(
                              `filter-item h-${ height } ml-2 px-4 flex select-none flex-shrink-0 items-center rounded-lg font-medium cursor-pointer justify-center filter-item overflow-hidden !text-base ${ classNames }`,
                              active && !showNewStyles && !activeBackground && `skin-secondary-background text-${ generateTextColor }`,
                              !active && passiveBackground && !showNewStyles && `bg-${ passiveBackground }`,
                              !active && !passiveBackground && !showNewStyles && 'bg-hover border-divider',
                              active && activeBackground && !showNewStyles && `bg-${ activeBackground }`,
                              !active && !showNewStyles && ' text-major dark:text-major-dark bg-panel dark:bg-panel-dark border dark:border-divider-dark border-divider',
                              i === data.length - 1 && 'item-last',
                              i === 0 && 'item-first',
                              active && v.name === 'Memberships' && 'w-full',
                              active && showNewStyles && `skin-primary-background text-major-dark font-medium`,
                              !active && showNewStyles && `text-secondary dark:text-secondary-dark  common-shadow bg-panel dark:bg-panel-dark font-medium hover:bg-hover dark:hover:bg-hover-dark`,
                              storeProps && 'text-base px-[14px] !h-10',
                              storeProps && !active && '!text-secondary !bg-panel',
                              storeProps && active && '!text-major-dark ',
                              storeProps && v.name === 'All' && '!h-[36px] mt-[3px] !w-[45px] text-base font-medium',
                              disabled && active && '!bg-disabled active:!bg-disabled !text-panel',
                              disabled && !active && '!text-disabled'
                           ) }
                        style={ customStyles }
                     >
                        {
                           v.icon && (
                              <Icon
                                 className={ `mr-2 ${ active ? activeIconClassName : passiveIconClassName } ` }
                                 color={ active ? generateTextColor : passiveIconColor ? passiveIconColor : 'major' }
                                 darkColor={ active ?  generateTextColor : 'major-dark' }
                                 name={ v.icon }
                                 size='xl'
                              />
                           )
                        }
                        <div className={ cx(
                           'font-medium flex',
                           v.name === 'Memberships' ? (active ? 'filter-item_text-sm' : 'filter-item_text') : ''
                        ) }>
                           <p className={ storeProps && v.name === 'All' ? '!w-[17px]' : '' }>
                              <span
                                 className={ `${ active ? activeTextClassName : passiveTextClassName }` }
                              >{ v.name }</span>
                              {v.name === 'Status' && status && <span className='font-normal capitalize'>: {status === 'incomplete' ? 'guest' : status}</span>}
                              {v.name === 'Memberships' && membership && <span className='font-normal capitalize'>: {membership}</span>}
                           </p>

                           {
                              v.isShowActiveValue && v.showValue  && (
                                 <>
                                    : &nbsp;
                                    <TruncateText
                                       text={ v.showValue }
                                       textClass='font-normal'
                                       textSize='16px'
                                       fontWeight='400'
                                       width='75px'
                                    />
                                 </>
                              )
                           }
                        </div>
                        {
                           active && multipl && !hideCancelButton && (
                              <Icon
                                 onClick={ (e) => {
                                    e.stopPropagation();
                                    onCancelFilter(v.value, v.filter_type);
                                 } }
                                 color='major-dark'
                                 name='cancel'
                                 className='ml-2'
                              />
                           )
                        }
                     </div>
                  );
               })
            }
            {
               children && children
            }
            <div style={ { minWidth: '2px' } } />
         </div>
      </div>
   );
};

Filter.defaultProps = {
   multipl: false,
   activeFilter: null,
   overflow: 'x-auto',
   backgroundColor: 'action',
   height: '11',
   marginLeft: '3',
   paddingX: '3',
   passiveTextClassName: '',
   hideCancelButton: false,
   customStyles: {},
   passiveIconColor: '',
   activeIconClassName: '',
   passiveIconClassName: '',
   classNames: '',
   disabled: false,
};

Filter.propTypes = {
   data: PropTypes.array,
   label: PropTypes.string,
   className: PropTypes.string,
   overflow: PropTypes.string,
   activeFilter: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
   ]),
   onSelectFilter: PropTypes.func,
   onCancelFilter: PropTypes.func,
   multipl: PropTypes.bool,
   status: PropTypes.string,
   membership: PropTypes.string,
   height: PropTypes.PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
   ]),
   marginLeft: PropTypes.PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
   ]),
   paddingX: PropTypes.PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
   ]),
   children: PropTypes.any,
   showNewStyles: PropTypes.bool,
   storeProps: PropTypes.bool,
   flexClassNames: PropTypes.string,
   activeTextClassName: PropTypes.string,
   passiveTextClassName: PropTypes.string,
   hideCancelButton: PropTypes.bool,
   passiveBackground: PropTypes.string,
   activeBackground: PropTypes.string,
   customStyles: PropTypes.object,
   passiveIconColor: PropTypes.string,
   activeIconClassName: PropTypes.string,
   passiveIconClassName: PropTypes.string,
   classNames: PropTypes.string,
   disabled: PropTypes.bool,
};

export default Filter;
